import React, { useState } from 'react';
import './MyProfile.scss';
//import AppointmentsModal from './AppointmentsModal';
import { styled } from '@mui/material/styles';
//import NotificationSnackbar from '../../components/Global/NotificationSnackbar/NotificationSnackbar';
import { useUser } from '../../context/UserContext';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { DataGrid } from '@mui/x-data-grid';

const RenewalDatesColorOverlayToggle = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: '#65C466',
        opacity: 1,
        border: 0,
        ...theme.applyStyles('dark', {
          backgroundColor: '#2ECA45',
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: theme.palette.grey[100],
      ...theme.applyStyles('dark', {
        color: theme.palette.grey[600],
      }),
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
      ...theme.applyStyles('dark', {
        opacity: 0.3,
      }),
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: '#E9E9EA',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
    ...theme.applyStyles('dark', {
      backgroundColor: '#39393D',
    }),
  },
}));

export default function AppointmentsTable({ ...props }) {
  const sixtyDaysRowColor = '#D4D9DF';
  const textRowColor = '#212121';
  const thirtyDaysRowColor = '#D88C8C';
  const sixtyToNinetyDaysRowColor = '#D9CBB3';
  const colorKeys = [
    { id: 0, label: '< 30 Days', color: thirtyDaysRowColor },
    { id: 1, label: '60-90 Days', color: sixtyToNinetyDaysRowColor },
    { id: 2, label: '> 90 Days', color: sixtyDaysRowColor },
  ];

  const [overlayChecked, setOverlayChecked] = useState(true);

  const handleOverlayChecked = (event) => {
    setOverlayChecked(event.target.checked);
  };

  const user = useUser();

  if (user.isHO || props.npnID == null) return <div>No Agent Information</div>;

  function checkDateForColorOverlay(targetDate) {
    if (!overlayChecked || targetDate === '') return 'default';

    const renewalDate = new Date(targetDate);
    const today = new Date();

    renewalDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const sixtyDaysFromToday = new Date(today);
    sixtyDaysFromToday.setDate(today.getDate() - 60);

    const thirtyDaysFromToday = new Date(today);
    thirtyDaysFromToday.setDate(today.getDate() - 30);

    //greater than 60 day window
    if (renewalDate < sixtyDaysFromToday) return 'sixty';

    //between thirty and sixty day window
    if (renewalDate >= sixtyDaysFromToday && renewalDate <= thirtyDaysFromToday) return 'inbetween';

    // Compare the target date with today and the date 30 days from today
    // A date is less than 30 days from today if it's in the future and within the 30-day window
    if (renewalDate > thirtyDaysFromToday && renewalDate < today) return 'thirty';

    return 'default';
  }

  /* function InvoicingTabs() {

        return (
            <div className="rightTabs">
                <Button variant="contained" color="primary" id="requestNewAppt" onClick={handleClickOpen}>Request Appointment</Button>
            </div>
        )

    }*/

  function TableColorKey() {
    return (
      <Box sx={{ display: 'flex' }}>
        {colorKeys.map((c, index) => (
          <Box
            key={c.id + '-' + index}
            sx={{ display: 'flex', alignItems: 'center', width: 'auto' }}
          >
            <Box sx={{ width: 16, height: 16, borderRadius: 999, backgroundColor: c.color }}></Box>
            <Typography sx={{ margin: '0 20px', width: 'max-content' }}>{c.label}</Typography>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <div>
      <div className="appointmentTabs">
        {overlayChecked && <TableColorKey />}
        <Box sx={{ textAlign: 'right', width: '100%', display: 'block' }}>
          <FormControlLabel
            sx={{ height: '100%' }}
            control={
              <RenewalDatesColorOverlayToggle
                sx={{ m: 1 }}
                onChange={handleOverlayChecked}
                checked={overlayChecked}
              />
            }
            label="Renewal Dates Overlay"
          />
        </Box>
        {/*<InvoicingTabs />*/}
      </div>

      <div style={{ height: 500, width: '100%' }}>
        {
          <DataGrid
            sx={{
              '& .MuiDataGrid-columnHeader': {
                backgroundColor: '#1976d2',
                color: '#fff',
                fontWeight: 'bold',
              },
              '& .MuiDataGrid-columnHeaderTitleContainer': {
                justifyContent: 'center',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: overlayChecked ? '' : 'inherit',
                color: textRowColor,
              },
              '& .MuiDataGrid-row.row-even': {
                backgroundColor: overlayChecked ? '' : '#f9f9f9',
                color: textRowColor,
              },
              '& p': {
                margin: 0,
              },
              '& .MuiTablePagination-actions': {
                marginTop: 0,
              },
              '.sixty': {
                backgroundColor: sixtyDaysRowColor,
                color: textRowColor,

                '&:hover': {
                  backgroundColor: sixtyDaysRowColor,
                },
              },
              '.thirty': {
                backgroundColor: thirtyDaysRowColor,
                color: textRowColor,

                '&:hover': {
                  backgroundColor: thirtyDaysRowColor,
                },
              },
              '.inbetween': {
                backgroundColor: sixtyToNinetyDaysRowColor,
                color: textRowColor,

                '&:hover': {
                  backgroundColor: sixtyToNinetyDaysRowColor,
                },
              },
              '.default': {
                color: textRowColor,
              },
              borderRadius: 2,
              boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
            }}
            disableColumnFilter
            disableColumnSelector
            disableDensitySelector
            disableRowSelectionOnClick
            rows={props.apptRowData}
            columns={props.apptColumns}
            getRowClassName={(params) => {
              if (overlayChecked) return checkDateForColorOverlay(params.row.renewalDate);
              return params.row.rowIndex % 2 === 0 ? 'row-even' : 'row-odd';
            }}
            loading={props.appointmentInfo.isLoading || props.appointmentInfo.isFetching}
            slotProps={{
              loadingOverlay: {
                variant: 'linear-progress',
                noRowsVariant: 'skeleton',
              },
            }}
          />
        }
      </div>
    </div>
  );
}
